document.addEventListener("click", function(event) {
  if (window.innerWidth >= 992) return;
  const heading = event.target.closest(".accordion");
  if (!heading) return;

  const panel = heading.nextElementSibling.nextElementSibling;
  const hr = heading.nextElementSibling;

  if (panel.classList.contains("show")) {
    panel.classList.remove("show");
    hr.style.display = "block";
    heading.classList.remove("active");
  } else {
    panel.classList.add("show");
    hr.style.display = "none";
    heading.classList.add("active");
  }
});

window.addEventListener("resize", function() {
  if (window.innerWidth < 992) return;
  document.querySelectorAll(".footer .accordion").forEach(function(heading) {
    heading.classList.remove("active");
    const panel = heading.nextElementSibling.nextElementSibling;
    const hr = heading.nextElementSibling;
    if (panel) panel.classList.remove("show");
    if (hr) hr.style.display = "";
  });
});
